/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import TaskEvent from '../../event/TaskEvent'
import { TaskState } from '../state/TaskState'

class TaskStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new TaskState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case TaskEvent.initialize:
        return state.clear()

      case TaskEvent.fetchOne:
        return state.merge(payload.task)

      case TaskEvent.onEdit:
        return state.set(payload.name, payload.value)

      default:
        return state
    }
  }
}

export default new TaskStore()
